import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router";

import { HELP_PBX } from "@/constants/HelpUrls";
import MasterDetail from "@/design/layouts/MasterDetail";
import { setHelpUrl } from "@/store/reducers/ui";

import { useHotkey } from "@tanstack/react-hotkeys";

import Account from "./Account";
import Pbx from "./Pbx";
import PbxList from "./PbxList";

function Overview() {
  const params = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(setHelpUrl(HELP_PBX));
  }, [dispatch]);

  useHotkey("Alt+N", () => navigate(`/pbx/${params.pbxId}/my-pbx/new`));

  return (
    <MasterDetail identifier="id" master={<PbxList />} detail={<Account />} empty={<Pbx />} emptyAccessKey="pbx" />
  );
}

export default Overview;
